import React, { createRef } from "react";
import useStyles from "./styles";

import { Grid, Dialog, Button, Container } from "@material-ui/core";
import { Images } from "config/images";

const DialogChangePassword = props => {
	const classes = useStyles();
	const { handleClose, open } = props;
	const nodeRef = createRef();

	return (
		<Dialog
			onClose={handleClose}
			aria-labelledby="customized-dialog-title"
			open={open}
			ref={nodeRef}
			fullScreen
		>
			<Container maxWidth="xs" style={{ padding: 0 }}>
				<Grid classes={{ root: classes.root }}>
					<Grid style={{ maxWidth: 444, position: "relative" }}>
						<Grid classes={{ root: classes.rootBg }}>
							<img src={Images.bgDevice} alt="bgDeviceActive" />
						</Grid>
						<Grid classes={{ root: classes.rootCity }}>
							<img src={Images.city} alt="city" />
						</Grid>
					</Grid>
					<Grid classes={{ root: classes.bodyPage }}>
						<Grid style={{ textAlign: "center" }}>
							<Grid
								style={{
									textAlign: "center",
									paddingBottom: 20
								}}
							>
								<img
									src={Images.verifyDeviceLock}
									alt={"verifyDeviceLock"}
									style={{ width: "100%", maxWidth: 270 }}
								/>
							</Grid>
							<Grid classes={{ root: classes.title }}>
								Tài khoản của bạn đã bị khóa do nhập sai mật
								khẩu quá 5 lần
							</Grid>
							<Grid classes={{ root: classes.subTitle }}>
								Vui lòng liên hệ bộ phận DMS để được biết thêm
								thông tin
							</Grid>
						</Grid>
					</Grid>
					<Grid classes={{ root: classes.rootFooter }}>
						<Button
							type="submit"
							classes={{
								root: classes.btnSubmit
							}}
							onClick={() => {
								handleClose();
							}}
						>
							Đóng
						</Button>
					</Grid>
				</Grid>
			</Container>
		</Dialog>
	);
};

export default DialogChangePassword;
